/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyPinMutationVariables = {|
  mobileNumber: string,
  pin: string,
|};
export type VerifyPinMutationResponse = {|
  +verifyPin: ?{|
    +refreshToken: ?string,
    +message: ?string,
    +token: ?string,
    +error: ?boolean,
    +user: ?{|
      +id: any,
      +username: string,
      +mobileNumber: string,
      +email: ?string,
      +shortUsername: ?string,
    |},
  |}
|};
export type VerifyPinMutation = {|
  variables: VerifyPinMutationVariables,
  response: VerifyPinMutationResponse,
|};
*/


/*
mutation VerifyPinMutation(
  $mobileNumber: String!
  $pin: String!
) {
  verifyPin(mobileNumber: $mobileNumber, pin: $pin) {
    refreshToken
    message
    token
    error
    user {
      id
      username
      mobileNumber
      email
      shortUsername
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobileNumber"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pin"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobileNumber",
        "variableName": "mobileNumber"
      },
      {
        "kind": "Variable",
        "name": "pin",
        "variableName": "pin"
      }
    ],
    "concreteType": "VerifyWithPin",
    "kind": "LinkedField",
    "name": "verifyPin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mobileNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortUsername",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyPinMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyPinMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dda90452f61bc1eed21349cdd44fcb0e",
    "id": null,
    "metadata": {},
    "name": "VerifyPinMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyPinMutation(\n  $mobileNumber: String!\n  $pin: String!\n) {\n  verifyPin(mobileNumber: $mobileNumber, pin: $pin) {\n    refreshToken\n    message\n    token\n    error\n    user {\n      id\n      username\n      mobileNumber\n      email\n      shortUsername\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8015e05bd98969b37dc62eb49d4e1956';

module.exports = node;
